import * as Shoelace from '@shoelace-style/shoelace';
import { SlVariant } from './slUtils';
import { escapeHtml } from './htmlUtils';
import { iconForSlVariant, type AppIcon } from './icons';

export interface NotifyOpts {
  variant: SlVariant;
  icon?: AppIcon;
  durationSecs: number;
}

export const defaultNotifyOpts: NotifyOpts = {
  variant: SlVariant.PRIMARY,
  durationSecs: 5
};

export function showNotification(
  message: string,
  opts?: Partial<NotifyOpts>
): Promise<void> {
  const {
    variant,
    icon = iconForSlVariant(SlVariant.PRIMARY),
    durationSecs
  } = { ...defaultNotifyOpts, ...opts };
  const alert: Shoelace.SlAlert = Object.assign(document.createElement('sl-alert'), {
    variant,
    closable: true,
    duration: 1000 * durationSecs,
    innerHTML: `
    <sl-icon library="${icon.library}" name="${icon.name}" slot="icon"></sl-icon>
    ${escapeHtml(message)}
  `
  });

  document.body.append(alert);
  return alert.toast();
}
